// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3jmR2","signatureButtonsRight":"ModalSign_signatureButtonsRight__3vESD"};